var lib_core = require("lib-core");

if(typeof window !== 'undefined'){
    var ui_extensions = require("ui-extensions");
}

var EcadioModelSelectorTrayView = function(root, model, statemachine, rootStateMachine, parentView, parentName, config) {
    var self = this;

    ui_extensions.TrayAssetSearchTabView.call(self, model, statemachine, rootStateMachine, parentView, parentName, config);
};

lib_core.inherit(EcadioModelSelectorTrayView, ui_extensions.TrayAssetSearchTabView);
module.exports = EcadioModelSelectorTrayView;

EcadioModelSelectorTrayView.prototype.showTabData = function(ref){
    var self = this;
    this.ref = ref;
    this.ref.getTemplate().clearContent();
    
    // Todo much of this function is a copy of the one inherited...
    $.each(ref.model.data(), function(index, element){
        var updated_at = (element["updated_at"] || false);
        if(!element['url']) return;

        if(!element['name']){
            var url = element['url'].split(/[\\\/]/);
            var name = url[url.length - 1];
            name = name.split('.')[0];
            element['name'] = name;
        }
        var component = self.ref.getTemplate().addItem(
            {
                "name": (element['name'] || ''),
                "description": (element['description'] || ''),
                "thumb_url": (element['thumbnailUrl'] || '')
            }
        );

        component.$el.on('Cioui:TrayTabItem:clicked', function(e, val){
             var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ECADIO_RESULT_SELECTED)
                 .data('url', element['url'])
                 .scope(self.model.scope());
            ref.model.parent().parent().visible(false); // TODO: violation of MVC!!!!
            ref.rootStateMachine.handle(cEvent);
            //self.fetchAndUpload3dModelToCS(result['url']);
        });

    });

};
